import type { ApplicantCountModel } from '../types';

import { Box, Alert } from '../../../../../../mads';
import { Discover } from '../../../../../../mads/icons';
import { type GettextInterface, useI18n } from '../../../../../../shared/I18n';

import { colors } from '@indeed/ifl-tokens/react-native';
import React from 'react';

export function getTodayCountText(gt: GettextInterface, count: ApplicantCountModel): string {
    return gt.npgettext(
        'Number of applicants for last 24 hours',
        ' {0} applicant today',
        ' {0} applicants today',
        count.last24hCount,
        count.last24hCount.toString(),
    );
}

function getApplicantCountText(gt: GettextInterface, count: ApplicantCountModel): string {
    const totalCountText =
        count.totalCount !== -1
            ? gt.npgettext(
                  'Total applicants for the job',
                  '{0} applicant on Indeed',
                  '{0} total applicants on Indeed, ',
                  count.totalCount,
                  count.totalCount.toString(),
              )
            : gt.gettext('? total applicants');

    return totalCountText;
}

export type IApplicantInsightsCountProps = {
    count: ApplicantCountModel;
    isZeroState?: boolean;
};

export const ApplicantInsightsCount: React.FC<IApplicantInsightsCountProps> = (props) => {
    const { count, isZeroState } = props;
    const gt = useI18n();
    const isTotalApplicantUnknown = count.totalCount === -1;
    const isEarlyApplicant: boolean = !isTotalApplicantUnknown && count.totalCount < 5;

    const earlyApplicantText = gt.gettext('Be an early applicant');

    let applicantSummaryText = !isTotalApplicantUnknown
        ? getApplicantCountText(gt, count)
        : gt.gettext('? total applicants, ');
    if (!isTotalApplicantUnknown && count.totalCount) {
        applicantSummaryText += getTodayCountText(gt, count);
    }

    return (
        <Box sx={{ marginBlockEnd: isZeroState ? 0 : 24 }} data-testid="applicant-insights-count">
            <Alert
                title={isEarlyApplicant ? earlyApplicantText : applicantSummaryText}
                explainerText={isEarlyApplicant ? applicantSummaryText : undefined}
                status={isEarlyApplicant ? 'warning' : 'info'}
                icon={<Discover color={colors.foregroundStatusInfo} />}
            />
        </Box>
    );
};

export default ApplicantInsightsCount;
